import { useContext, useState } from "react";
import { Button, Checkbox, IconGoogle } from "../../../components/atoms";
import {
  FlatpickerHourGroup,
  InputGroup,
  SelectGroup,
} from "../../../components/molecules";
import { AuthContext } from "../../../contexts/Auth/AuthContext";
import { NotificationContext } from "../../../contexts/NotificationCTX/NotificationContext";
import { api, convertDateTimeToPattern as dateFormat } from "../../../helpers";

export function Reservas() {
  const { applicationData } = useContext(AuthContext);
  const {
    setType,
    setShow,
    setText: setTextAlert,
  } = useContext(NotificationContext);

  const [campoObrigatorioDataInicial, setcampoObrigatorioDataInicial] =
    useState<boolean>(false);
  const [campoObrigatorioDataFinal, setcampoObrigatorioDataFinal] =
    useState<boolean>(false);
  const [campoObrigatorioBarco, setcampoObrigatorioBarco] =
    useState<boolean>(false);
  const [campoObrigatorioRelatorio, setcampoObrigatorioRelatorio] =
    useState<boolean>(false);
  const [campoObrigatorioOrigem, setcampoObrigatorioOrigem] =
    useState<boolean>(false);
  const [campoObrigatorioDestino, setcampoObrigatorioDestino] =
    useState<boolean>(false);
  const [campoObrigatorioOrdenar, setcampoObrigatorioOrdenar] =
    useState<boolean>(false);
  const [campoObrigatorioTipoPeriodo, setcampoObrigatorioTipoPeriodo] =
    useState<boolean>(false);
  const [campoObrigatorioCliente, setcampoObrigatorioCliente] =
    useState<boolean>(false);
  const [dataInicial, setDataInicial] = useState(new Date());
  const [dataFinal, setDataFinal] = useState(new Date());
  const [origem, setOrigem] = useState("0");
  const [tipoperiodo, setTipoPeriodo] = useState("reserva.DataReserva");
  const [ordenar, setOrdenar] = useState("reserva.DataReserva");
  const [destino, setDestino] = useState("0");
  const [barco, setBarco] = useState("0");
  const [relatorio, setRelatorio] = useState("Todas");
  const [cliente, setCliente] = useState(
    applicationData.acesso !== "funcionario" ? applicationData.funcionario : "0"
  )
  const [tipocliente, settipoCliente] = useState("0");
  const [reserva, setReserva] = useState("0");
  const [passageiro, setPassageiro] = useState("0");
  const [aguardaPagto, setAguardaPagto] = useState<boolean>(false);
  const [whatsapp, setWhatsapp] = useState<boolean>(false);
  const [emAnalise, setEmAnalise] = useState<boolean>(false);
  const [paga, setPaga] = useState<boolean>(false);
  const [disponivel, setDisponivel] = useState<boolean>(false);
  const [disputa, setDisputa] = useState<boolean>(false);
  const [devolvida, setDevolvida] = useState<boolean>(false);
  const [cancelada, setCancelada] = useState<boolean>(false);
  const [excluidas, setExcluidas] = useState<boolean>(false);

  const gravar = async () => {
    try {
      const { data: pdf } = await api.get(
        "/api/relreservas/" +
          cliente +
          "/" +
          barco +
          "/" +
          origem +
          "/" +
          destino +
          "/" +
          ordenar +
          "/" +
          dateFormat(dataInicial) +
          "/" +
          dateFormat(dataFinal) +
          "/" +
          tipoperiodo +
          "/" +
          relatorio +
          "/" +
          reserva +
          "/" +
          passageiro +
          "/" +
          tipocliente +
          "/" +
          aguardaPagto +
          "/" +
          emAnalise +
          "/" +
          paga +
          "/" +
          disponivel +
          "/" +
          disputa +
          "/" +
          devolvida +
          "/" +
          cancelada +
          "/" +
          excluidas,
        {
          headers: { Authorization: `Bearer ${applicationData.token}` },
          responseType: "blob",
        }
      );

      if (pdf.type !== "application/json") {
        const url = window.URL.createObjectURL(pdf);
        window.open(url, "_blank");
      } else {
        setType("danger");
        setTextAlert("nenhum dado encontrado no intervalo selecionado!");
        setShow(true);
      }
    } catch (error) {
      setType("danger");
      setTextAlert("erro na geração do relatorio!");
      setShow(true);
    }
  };

  return (
    <div>
      <h2>Relatorio de Reservas</h2>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <FlatpickerHourGroup
            label="Data/Hora Inicial"
            messageError={
              campoObrigatorioDataInicial ? "Campo obrigatório!" : ""
            }
            value={dataInicial}
            id="data-ini"
            onChange={([date]) => {
              if (String(date) !== "undefined") {
                setDataInicial(date);
                setcampoObrigatorioDataInicial(false);
              } else {
                setcampoObrigatorioDataInicial(true);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <FlatpickerHourGroup
            label="Data/Hora Final"
            messageError={campoObrigatorioDataFinal ? "Campo obrigatório!" : ""}
            value={dataFinal}
            id="data-fim"
            onChange={([date]) => {
              if (String(date) !== "undefined") {
                setDataFinal(date);
                setcampoObrigatorioDataFinal(false);
              } else {
                setcampoObrigatorioDataFinal(true);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={tipoperiodo}
            messageError={
              campoObrigatorioTipoPeriodo ? "Campo obrigatório!" : ""
            }
            id="periodo"
            label="Tipo de periodo"
            options={[
              { text: "DATA DA RESERVA", value: "reserva.DataReserva" },
              { text: "DATA DO EMBARQUE", value: "Horario" },
            ]}
            onChange={(e) => {
              if (e.target.value !== "") {
                setTipoPeriodo(e.target.value);
                setcampoObrigatorioTipoPeriodo(false);
              }
              if (e.target.value === "") setcampoObrigatorioTipoPeriodo(true);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={barco}
            messageError={campoObrigatorioBarco ? "Campo obrigatório!" : ""}
            id="barco"
            label="Barco"
            options={applicationData.barcos?.map((barco: Barco) => ({
              text: barco.nome,
              value: barco.codigo,
            }))}
            onChange={(e) => {
              if (e.target.value !== "") {
                setBarco(e.target.value);
                setcampoObrigatorioBarco(false);
              }
              if (e.target.value === "") setcampoObrigatorioBarco(true);
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={origem}
            messageError={campoObrigatorioOrigem ? "Campo obrigatório!" : ""}
            id="origem"
            label="Origem"
            options={applicationData.destinos.map((destino: Destino) => ({
              text: destino.nome,
              value: destino.codigo,
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 20 && Number(e.target.value) >= 0) {
                setOrigem(e.target.value);
                setcampoObrigatorioOrigem(false);
              }
              if (e.target.value === "") setcampoObrigatorioOrigem(true);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={destino}
            messageError={campoObrigatorioDestino ? "Campo obrigatório!" : ""}
            id="destino"
            label="Destino"
            options={applicationData.destinos.map((destino: Destino) => ({
              text: destino.nome,
              value: destino.codigo,
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 20 && Number(e.target.value) >= 0) {
                setDestino(e.target.value);
                setcampoObrigatorioDestino(false);
              }
              if (e.target.value === "") setcampoObrigatorioDestino(true);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={ordenar}
            messageError={campoObrigatorioOrdenar ? "Campo obrigatório!" : ""}
            id="ordenar"
            label="Ordenar por"
            options={[
              { text: "DATA DA RESERVA", value: "reserva.DataReserva" },
              { text: "DATA DO EMBARQUE", value: "Horario" },
              { text: "CLIENTE", value: "parceiro.nome" },
              { text: "RESERVA", value: "reserva.Codigo" },
            ]}
            onChange={(e) => {
              if (e.target.value !== "") {
                setOrdenar(e.target.value);
                setcampoObrigatorioOrdenar(false);
              }
              if (e.target.value === "") setcampoObrigatorioOrdenar(true);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={relatorio}
            messageError={campoObrigatorioRelatorio ? "Campo obrigatório!" : ""}
            id="relatorio"
            label="Tipo de Cliente"
            options={[
              { text: "AGENCIAS", value: "Agencias" },
              { text: "VENDAS DIRETAS", value: "Vendas Diretas" },
              { text: "TODAS", value: "Todas" },
            ]}
            onChange={(e) => {
              if (e.target.value !== "") {
                setRelatorio(e.target.value);
                setcampoObrigatorioRelatorio(false);
              }
              if (e.target.value === "") setcampoObrigatorioRelatorio(true);
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-6">
          <SelectGroup
            value={cliente}
            messageError={campoObrigatorioCliente ? "Campo obrigatório!" : ""}
            readOnly={applicationData.acesso !== "funcionario"}
            id="cliente"
            label="Cliente"
            options={applicationData.clientes.map((cliente: Cliente) => ({
              text: cliente.nome,
              value: cliente.codigo,
            }))}
            onChange={(e) => {
              if (
                Number(e.target.value) <= 10000 &&
                Number(e.target.value) >= 0
              ) {
                setCliente(e.target.value);
                setcampoObrigatorioCliente(false);
              }
              if (e.target.value === "") setcampoObrigatorioCliente(true);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="Reserva"
            id="reserva"
            type="number"
            value={reserva}
            autoComplete="off"
            onChange={(e) => {
              if (
                Number(e.target.value) <= 1000000 &&
                Number(e.target.value) >= 0
              ) {
                setReserva(e.target.value);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="Passageiro"
            id="passageiro"
            value={passageiro}
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value === "") setPassageiro("0");
              else {
                setPassageiro(e.target.value);
              }
            }}
          />
        </div>
      </div>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={tipocliente}
            id="tipocliente"
            label="Tipo Cliente"
            options={applicationData.gparceiros?.map((gparceiro: GParceiro) => ({
              text: gparceiro.nome,
              value: gparceiro.codigo,
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 100 && Number(e.target.value) > 0) {
                settipoCliente(e.target.value);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
          <Checkbox
            appearance="primary"
            id="whatsapp"
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value) {
                const valor = Boolean(e.target.checked);
                setWhatsapp(valor);
                setPassageiro(valor ? 'WhatsApp' : '0');
              }
              
            }}
          />
          <label htmlFor="cancelada">Whatsapp</label>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12 col-lg-2">
          <label htmlFor="agPagto">Status de vendas</label>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
          <Checkbox
            appearance="primary"
            id="aguardaPagto"
            autoComplete="off"
            onChange={(e) => {
              setAguardaPagto(Boolean(e.target.value));
            }}
          />
          <label htmlFor="aguardaPagto">Aguarda Pagto</label>
        </div>
        <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
          <Checkbox
            appearance="primary"
            id="analise"
            autoComplete="off"
            onChange={(e) => {
              setEmAnalise(Boolean(e.target.value));
            }}
          />
          <label htmlFor="analise">Em Analise</label>
        </div>
        <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
          <Checkbox
            appearance="primary"
            id="paga"
            autoComplete="off"
            onChange={(e) => {
              setPaga(Boolean(e.target.value));
            }}
          />
          <label htmlFor="paga">Paga</label>
        </div>
        <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
          <Checkbox
            appearance="primary"
            id="disponivel"
            autoComplete="off"
            onChange={(e) => {
              setDisponivel(Boolean(e.target.value));
            }}
          />
          <label htmlFor="disponivel">Disponivel</label>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
          <Checkbox
            appearance="primary"
            id="disputa"
            autoComplete="off"
            onChange={(e) => {
              setDisputa(Boolean(e.target.value));
            }}
          />
          <label htmlFor="disputa">Disputa</label>
        </div>
        <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
          <Checkbox
            appearance="primary"
            id="devolvida"
            autoComplete="off"
            onChange={(e) => {
              setDevolvida(Boolean(e.target.value));
            }}
          />
          <label htmlFor="devolvida">Devolvida</label>
        </div>
        <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
          <Checkbox
            appearance="primary"
            id="cancelada"
            autoComplete="off"
            onChange={(e) => {
              if (e.target.value) {
                setCancelada(Boolean(e.target.value));
              }
            }}
          />
          <label htmlFor="cancelada">Cancelada</label>
        </div>
        <div className="col-sm-12 col-lg-3 d-flex align-items-center gap-2">
          <Checkbox
            appearance="primary"
            id="excluida"
            autoComplete="off"
            onChange={(e) => {
              setExcluidas(Boolean(e.target.value));
            }}
          />
          <label htmlFor="excluida">Reservas Excluidas</label>
        </div>
      </div>

      <div className="row mt-3"></div>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <Button
            appearance="success"
            onClick={() => {
              gravar();
            }}
          >
            Gerar Relatorio<IconGoogle>picture_as_pdf</IconGoogle>
          </Button>
        </div>
      </div>
    </div>
  );
}
